import { IDocumentStatus } from '@cincel/client';
import { translations } from 'translations';

export function statusOfDocument(document, t) {
  switch (document.status) {
    case IDocumentStatus.SIGNED:
      return t(translations.DOCUMENT_PAGES.SIGNED);
      break;
    case IDocumentStatus.UNSIGNED:
      return t(translations.DOCUMENT_PAGES.NO_SIGNS);
      break;
    case IDocumentStatus.PARTIALLY_SIGNED:
      return `${t(translations.DOCUMENT_PAGES.PARTIALLY_SIGNED)}`;
      break;
    default:
      return t(translations.DOCUMENT_PAGES.NO_SIGNS);
      break;
  }
}
